import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Switch } from './ui/switch';
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Save } from 'lucide-react';

export default function DispositifFormContent({ formData, setFormData, editingDispositif, handleSubmit, handleCloseDialog, TYPES_ACTIVITE }) {
  return (
              <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>
                    {editingDispositif ? 'Modifier le dispositif' : 'Créer un nouveau dispositif'}
                  </DialogTitle>
                  <DialogDescription>
                    Remplissez les informations du dispositif solidaire
                  </DialogDescription>
                </DialogHeader>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  {/* Informations de base */}
                  <div className="space-y-4">
                    <div>
                      <Label htmlFor="nom">Nom du dispositif *</Label>
                      <Input
                        id="nom"
                        value={formData.nom}
                        onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
                        placeholder="Ex: RCDS Standard"
                        required
                      />
                    </div>

                    <div>
                      <Label htmlFor="description">Description *</Label>
                      <Textarea
                        id="description"
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        placeholder="Description détaillée du dispositif..."
                        rows={3}
                        required
                      />
                    </div>

                    <div>
                      <Label htmlFor="type_activite">Type d'activité *</Label>
                      <Select 
                        value={formData.type_activite} 
                        onValueChange={(value) => setFormData({ ...formData, type_activite: value })}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Sélectionner un type" />
                        </SelectTrigger>
                        <SelectContent>
                          {TYPES_ACTIVITE.map((type) => (
                            <SelectItem key={type.value} value={type.value}>{type.label}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>

                    <div>
                      <Label htmlFor="categorie">Catégorie</Label>
                      <Input
                        id="categorie"
                        value={formData.categorie}
                        onChange={(e) => setFormData({ ...formData, categorie: e.target.value })}
                        placeholder="Ex: Assurance, Garantie..."
                      />
                    </div>
                  </div>

                  {/* Tarifs */}
                  <div className="border-t pt-4">
                    <h4 className="font-semibold mb-3">Tarification</h4>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <Label htmlFor="tarif_base">Tarif de base (€) *</Label>
                        <Input
                          id="tarif_base"
                          type="number"
                          step="0.01"
                          value={formData.tarif_base}
                          onChange={(e) => setFormData({ ...formData, tarif_base: e.target.value })}
                          placeholder="0.00"
                          required
                        />
                      </div>

                      <div>
                        <Label htmlFor="validite_jours">Validité (jours) *</Label>
                        <Input
                          id="validite_jours"
                          type="number"
                          value={formData.validite_jours}
                          onChange={(e) => setFormData({ ...formData, validite_jours: e.target.value })}
                          placeholder="360"
                          required
                        />
                      </div>

                      <div>
                        <Label htmlFor="tarif_par_jour">Tarif par jour (€)</Label>
                        <Input
                          id="tarif_par_jour"
                          type="number"
                          step="0.01"
                          value={formData.tarif_par_jour}
                          onChange={(e) => setFormData({ ...formData, tarif_par_jour: e.target.value })}
                          placeholder="0.00"
                        />
                      </div>

                      <div>
                        <Label htmlFor="tarif_par_chantier">Tarif par chantier (€)</Label>
                        <Input
                          id="tarif_par_chantier"
                          type="number"
                          step="0.01"
                          value={formData.tarif_par_chantier}
                          onChange={(e) => setFormData({ ...formData, tarif_par_chantier: e.target.value })}
                          placeholder="0.00"
                        />
                      </div>

                      <div>
                        <Label htmlFor="prix_particulier">Prix Bénéficiaire Particulier (€)</Label>
                        <Input
                          id="prix_particulier"
                          type="number"
                          step="0.01"
                          value={formData.prix_particulier}
                          onChange={(e) => setFormData({ ...formData, prix_particulier: e.target.value })}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Visibilité */}
                  <div className="border-t pt-4">
                    <h4 className="font-semibold mb-3">Visibilité par rôle</h4>
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <Label htmlFor="visible_pro">Visible pour Bénéficiaires Professionnels</Label>
                        <Switch
                          id="visible_pro"
                          checked={formData.visible_beneficiaire_pro}
                          onCheckedChange={(checked) => 
                            setFormData({ ...formData, visible_beneficiaire_pro: checked })
                          }
                        />
                      </div>

                      <div className="flex items-center justify-between">
                        <Label htmlFor="visible_particulier">Visible pour Bénéficiaires Particuliers</Label>
                        <Switch
                          id="visible_particulier"
                          checked={formData.visible_beneficiaire_particulier}
                          onCheckedChange={(checked) => 
                            setFormData({ ...formData, visible_beneficiaire_particulier: checked })
                          }
                        />
                      </div>

                      <div className="flex items-center justify-between">
                        <Label htmlFor="visible_cooper">Visible pour COOPER'S</Label>
                        <Switch
                          id="visible_cooper"
                          checked={formData.visible_cooper}
                          onCheckedChange={(checked) => 
                            setFormData({ ...formData, visible_cooper: checked })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <DialogFooter>
                    <Button type="button" variant="outline" onClick={handleCloseDialog}>
                      <X className="h-4 w-4 mr-2" />
                      Annuler
                    </Button>
                    <Button type="submit" className="bg-coppam-gold hover:bg-coppam-gold/90">
                      <Save className="h-4 w-4 mr-2" />
                      {editingDispositif ? 'Mettre à jour' : 'Créer'}
                    </Button>
                  </DialogFooter>
                </form>
              </DialogContent>
  );
}
